import React from 'react'
import styles from './ModuleCSS/Strategies.module.css'

function Strategies() {
    return (
        <div className={styles.container}>
            <h2>Strategier</h2>
        </div>
    )
}

export default Strategies
